import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-chargeInput-control-label-view, [app-fuelInput-control-label-view]',
  templateUrl: './chargeInput-control-label-view.component.html',
  styleUrls: ['./chargeInput-control-label-view.component.scss']
})
export class ChargeInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
